// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {chain, includes, isRegExp} from 'lodash';

// Components
import Button from './button';

// Configs
import errorConfig from '../configs/error-config';

// Styles
import './error.scss';

export default class Error extends Component {
    getClass() {
        const {absolutePositioned, fixedPositioned, className} = this.props;

        return classnames(
            {
                error: true,
                error_absolute: absolutePositioned,
                error_fixed: fixedPositioned,
            },
            className
        );
    }

    getAccordionProps() {
        return {
            disableDefaultToggle: true,
            detailsRenderer: this.renderErrorDetails,
        };
    }

    getErrorMessage() {
        const {error} = this.props;

        return (
            chain(errorConfig)
                .find(item => (isRegExp(item.pattern) ? item.pattern.test(error) : includes(error, item.pattern)))
                .get('message')
                .value() || error
        );
    }

    renderDetailAccordion(errorMessage) {
        return null;
    }

    renderError() {
        const {children} = this.props;
        const errorMessage = this.getErrorMessage();

        return (
            <div className={this.getClass()}>
                <div className="error--content">{errorMessage}</div>
                {this.renderClearButton()}
                {this.renderResetButton()}
                {this.renderDetailAccordion(errorMessage)}
                {children}
            </div>
        );
    }

    renderErrorDetails = () => {
        const {error} = this.props;

        return <div className="error--details">{error}</div>;
    };

    renderClearButton() {
        const {onClear, clearButtonChildren} = this.props;

        return onClear ? (
            <Button className="error--button" onClick={onClear}>
                {clearButtonChildren}
            </Button>
        ) : null;
    }

    renderResetButton() {
        const {onReset, resetButtonChildren} = this.props;

        return onReset ? (
            <Button className="error--button" onClick={onReset}>
                {resetButtonChildren}
            </Button>
        ) : null;
    }

    render() {
        const {children, error} = this.props;

        return children || (error && error !== '') ? this.renderError() : null;
    }
}

Error.propTypes = {
    absolutePositioned: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    clearButtonChildren: PropTypes.node,
    error: PropTypes.string,
    fixedPositioned: PropTypes.bool,
    onClear: PropTypes.func,
    onReset: PropTypes.func,
    resetButtonChildren: PropTypes.node,
};

Error.defaultProps = {
    clearButtonChildren: 'clear error',
    resetButtonChildren: 'reset',
};
